import moment from 'moment';
import { ConfigService } from '../services/config.service';
import { Docket } from '../../models';

export function contractIdComparator(contract1: Docket, contract2: Docket) {
  return contract1.id - contract2.id;
}
